// **********************************************************
// News Slider
// **********************************************************

const newsImageSlider = document.querySelectorAll('[data-slider="news-image-slider"]');
const newsTextSlider = document.querySelectorAll('[data-slider="news-text-slider"]');

// Text Slider

const newsTextSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 1000,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
};

newsTextSlider.forEach((el) => new Swiper(el, newsTextSliderOptions));

// Image Slider

const newsImageSliderOptions = {
  slidesPerView: 1.2,
  speed: 1000,
  spaceBetween: 0,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  watchOverflow: true,
  effect: 'creative',
  creativeEffect: {
    limitProgress: 10,
    prev: {
      origin: 'center',
      translate: ['-83%', '0%', 108],
      rotate: [0, 0, -12],
      scale: 0.46,
    },
    next: {
      origin: ' center',
      translate: ['100%', '0%', -108],
      rotate: [0, 0, 12],
      scale: 0.55,
    },
  },
  breakpoints: {
    767: {
      creativeEffect: {
        limitProgress: 6,
        prev: {
          origin: 'center',
          translate: ['-64%', '0%', 108],
          rotate: [0, 0, -12],
          scale: 0.46,
        },
        next: {
          origin: ' center',
          translate: ['79%', '0%', -108],
          rotate: [0, 0, 12],
          scale: 0.55,
        },
      },
    },
    1920: {
      slidesPerView: 1.68,
    },
  },
};

newsImageSlider.forEach((el) => {
  const newsSlider = el.closest('.news-slider');
  const arrowRight = newsSlider.querySelector('.swiper-button-next');
  const arrowLeft = newsSlider.querySelector('.swiper-button-prev');

  newsImageSliderOptions.navigation.nextEl = arrowRight;
  newsImageSliderOptions.navigation.prevEl = arrowLeft;

  const textSliderEle = newsSlider.querySelector('[data-slider="news-text-slider"]');
  const textSlider = textSliderEle.swiper;

  const imageSlider = new Swiper(el, newsImageSliderOptions);

  imageSlider.controller.control = textSlider;
  textSlider.controller.control = imageSlider;
});
